import { defineCustomElement } from 'vue'
import { createPinia } from 'pinia'
import App from './App.ce.vue'

const LocationTrackerMap = defineCustomElement(App, {
  configureApp: (app) => app.use(createPinia()),
})

if (!customElements.get('location-tracker-map')) {
  customElements.define('location-tracker-map', LocationTrackerMap)
}
